import { FC, lazy, Suspense } from 'react'
import { Route, Routes } from 'react-router'
import r from 'routes'

import AuthenticatedApp from '@/components/layout/auth/authenticated-app'
import LayoutMain from '@/components/layout/main'
import Sales from '@/pages/sales'
import Settings from '@/pages/settings'
import Support from '@/pages/support'
import SupportTicket from '@/pages/support/ticket'

import EmbeddedApp from './components/embedded-app'
import Home from './pages/home'
import Resources from './pages/resources'
import WatchTower from './watch-tower/pages'

const OneTimePasscode = lazy(() => import('@/pages/apps/one-time-passcode'))
const Passkeys = lazy(() => import('@/pages/apps/passkeys'))
const DocumentSignature = lazy(() => import('@/pages/apps/document-signature'))
const EForm = lazy(() => import('@/pages/apps/e-form'))
const Payments = lazy(() => import('@/pages/apps/payments'))
const IdentityVerification = lazy(() => import('@/pages/apps/identity-verification'))
const GatewayPayments = lazy(() => import('@/pages/apps/gateway-payments'))

const App: FC = () => {
  return (
    <EmbeddedApp>
      <AuthenticatedApp>
        <Routes>
          <Route path={r.watchTower.root + '/*'} Component={WatchTower} />
          <Route
            path="/*"
            element={
              <>
                <LayoutMain>
                  <Suspense fallback={<></>}>
                    <Routes>
                      <Route path={r.root} Component={Home} />
                      <Route path={r.settings.root + '/*'} Component={Settings} />
                      <Route path={r.support.root} Component={Support} />
                      <Route path={r.support.ticket} Component={SupportTicket} />
                      <Route path={r.sales.root} Component={Sales} />
                      <Route path={r.resources.root} Component={Resources} />
                      <Route path={r.apps['document-signature'].root + '/*'} Component={DocumentSignature} />
                      <Route path={r.apps['e-form'].root + '/*'} Component={EForm} />
                      <Route path={r.apps['gateway-payments'].root + '/*'} Component={GatewayPayments} />
                      <Route path={r.apps['identity-verification'].root + '/*'} Component={IdentityVerification} />
                      <Route path={r.apps['one-time-passcode'].root + '/*'} Component={OneTimePasscode} />
                      <Route path={r.apps['passkeys'].root + '/*'} Component={Passkeys} />
                      <Route path={r.apps['payments'].root + '/*'} Component={Payments} />
                    </Routes>
                  </Suspense>
                </LayoutMain>
              </>
            }
          />
        </Routes>
      </AuthenticatedApp>
    </EmbeddedApp>
  )
}

export default App
